"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DateTimeProvider_1 = require("../Util/DateTimeProvider");
const dateTimeCheck_1 = __importDefault(require("../Util/dateTimeCheck"));
const moment_1 = __importDefault(require("moment"));
const cache_1 = require("@almservices-cl/cache");
const clock_1 = require("@almservices-cl/clock");
class DateTimeProviderMock {
    constructor(dateTimeConfigCacheInterface = new clock_1.DateTimeConfig(new cache_1.InMemoryCache(), {
        dateTime: "YYYY-MM-DD HH:mm:ss",
        date: "YYYY-MM-DD",
        time: "HH:mm:ss",
    })) {
        this.currentRawValue = DateTimeProviderMock.DEFAULT_DATE_TIME_RAW;
        /**
         * @inheritDoc
         */
        this.current = (timezone) => this.fromDateTime(this.currentRawValue, timezone);
        /**
         * @inheritDoc
         */
        this.fromDateTime = (dateTime, timezone) => (0, dateTimeCheck_1.default)((0, moment_1.default)(dateTime)
            .utcOffset(timezone.toString())
            .format(this.dateTimeFormat));
        /**
         * @inheritDoc
         */
        this.fromDateTimeToDate = (dateTime) => {
            const momentObj = (0, moment_1.default)(dateTime.substr(0, 10), this.dateTimeFormat);
            return (0, dateTimeCheck_1.default)(momentObj.format(this.dateFormat));
        };
        /**
         * @inheritDoc
         */
        this.currentRaw = (_timezone) => {
            const dt = (0, moment_1.default)(this.currentRawValue);
            return {
                date: (0, dateTimeCheck_1.default)(dt.format("YYYY-MM-DDTHH:mm:ssZ")),
                format: DateTimeProvider_1.FORMAT_RAW,
            };
        };
        /**
         * @inheritDoc
         */
        this.currentDate = () => (0, dateTimeCheck_1.default)((0, moment_1.default)(this.currentRawValue).format(this.dateFormat));
        /**
         * @inheritDoc
         */
        this.dayOfWeek = (date) => {
            const day = (0, dateTimeCheck_1.default)((0, moment_1.default)(date, this.dateFormat).isoWeekday());
            // @ts-ignore
            return day - 1;
        };
        this.dayOfWeekRaw = (date, dateFormat) => {
            return (0, dateTimeCheck_1.default)((0, moment_1.default)(date, dateFormat ? dateFormat : this.dateFormat).isoWeekday());
        };
        /**
         * @inheritDoc
         */
        this.currentTimestamp = () => (0, dateTimeCheck_1.default)(new Date(this.currentRawValue).getTime());
        this.moveMillisecond = (millisecond) => {
            this.currentRawValue = (0, moment_1.default)(this.currentRawValue)
                .add({ millisecond })
                .format();
        };
        dateTimeConfigCacheInterface.onChange(this);
    }
    setFormats(dateTimeFormat, dateFormat, _timeFormat) {
        this.dateTimeFormat = dateTimeFormat;
        this.dateFormat = dateFormat;
    }
    fromNow(date, timeZone) {
        let momentObj = (0, moment_1.default)(date, date.substr(10, 1) === "T" ? "YYYY-MM-DDTHH:mm:ssZ" : this.dateTimeFormat)
            .locale("en_US")
            .utcOffset(timeZone.toString());
        const momentNow = (0, moment_1.default)(this.currentRaw(DateTimeProvider_1.UTCTimeZone.z()).date);
        if (momentObj.diff(momentNow, "day") !== 0) {
            momentObj = momentObj.endOf("day");
        }
        return momentObj.from(momentNow);
    }
    weekFromDate(date) {
        return (0, moment_1.default)(date).isoWeek();
    }
}
DateTimeProviderMock.DEFAULT_DATE_TIME_RAW = "2019-06-01T10:10:10+01:30";
DateTimeProviderMock.DEFAULT_DATE_TIME_RAW_LATER = "2019-07-20T20:20:10+01:30";
DateTimeProviderMock.DEFAULT_DATE_TIME = "2019-06-01 10:10:10";
DateTimeProviderMock.DEFAULT_DATE_TIME_LATER = "2019-07-20 20:20:20";
DateTimeProviderMock.DEFAULT_TIME_ZONE = new DateTimeProvider_1.UTCTimeZone(1, 30);
exports.default = DateTimeProviderMock;
//# sourceMappingURL=DateTimeProviderMock.js.map